import { render, staticRenderFns } from "./TestScoringComponent.vue?vue&type=template&id=55c64e73&scoped=true&"
import script from "./TestScoringComponent.vue?vue&type=script&lang=js&"
export * from "./TestScoringComponent.vue?vue&type=script&lang=js&"
import style0 from "./TestScoringComponent.vue?vue&type=style&index=0&id=55c64e73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c64e73",
  null
  
)

export default component.exports